module.exports = __webpack_public_path__ + "static/img/biasfx2-workflow-2.9ff58f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/biasfx2-workflow-2.jpg
// module id = Xxy7
// module chunks = 13